(()=>{
 if(window.__pbPurchaseRow)return;
 window.__pbPurchaseRow=true;
 function init(){
  const dataEl=document.getElementById('pb-purchase-row-data');
  const main=document.querySelector('#MainContent .product-page-layout');
  if(!dataEl||!main)return;
  let data;try{data=JSON.parse(dataEl.textContent);}catch{return;}
  const accessory=['reusable-eye-masks','ultra-soft-microfiber-face-cloth'].includes(data.handle);
  const formatter=new Intl.NumberFormat(document.documentElement.lang||'en',{
   style:'currency',currency:data.currency||'USD',currencyDisplay:'narrowSymbol'
  });
  let scheduled=false;
  const setText=(e,text)=>{if(e&&e.textContent!==text)e.textContent=text;};
  function update(){
   scheduled=false;
   const form=main.querySelector('form.form_add_cartp');
   const row=form?.querySelector('.quantity_input_add_to_cart');
   const button=row?.querySelector('.submit_add_cart');
   if(!form||!row||!button)return;
   let summary=row.querySelector('.pb-purchase-summary');
   if(!summary){
    summary=document.createElement('div');
    summary.className='pb-purchase-summary';
    summary.setAttribute('aria-live','polite');
    summary.setAttribute('aria-atomic','true');
    const amount=document.createElement('span');
    amount.className='pb-purchase-summary__price';
    const note=document.createElement('span');
    note.className='pb-purchase-summary__note';
    summary.append(amount,note);
    row.insertBefore(summary,button);
    row.classList.add('pb-purchase-row');
   }
   const id=form.querySelector('[name="id"]')?.value;
   const variant=data.variants.find(v=>String(v.id)===String(id));
   if(!variant)return;
   main.classList.add('pb-single-purchase');
   form.closest('.main-product_block-spacing')?.classList.add('pb-buy-block');
   const quantity=Math.max(1,parseInt(form.querySelector('[name="quantity"]')?.value||'1',10)||1);
   const radio=main.querySelector('input[name="selling_plan"]:checked:not(:disabled)');
   let planId='';
   if(!accessory){
    if(radio){
     planId=radio.value;
     if(planId){
      const wrapper=radio.closest('.appstle_sub_widget');
      planId=wrapper?.querySelector('select.appstle_select')?.value||planId;
     }
    }else{
     planId=form.querySelector('input[name="selling_plan"]:not(:disabled),select[name="selling_plan"]:not(:disabled)')?.value||'';
    }
   }
   const allocation=variant.plans.find(p=>String(p.id)===String(planId));
   const unitPrice=allocation?allocation.price:variant.price;
   const price=formatter.format(unitPrice*quantity/100);
   const mode=allocation?'Subscription':'One-time purchase';
   const note=(quantity>1?quantity+' items · ':'')+mode;
   setText(summary.querySelector('.pb-purchase-summary__price'),price);
   setText(summary.querySelector('.pb-purchase-summary__note'),note);
   summary.dataset.variant=id;
   summary.dataset.sellingPlan=allocation?String(allocation.id):'';
   summary.dataset.quantity=String(quantity);
   const sticky=document.getElementById('pbc-sticky');
   if(sticky){
    setText(sticky.querySelector('[data-pbc-sticky-price]'),price);
    const stickyButton=sticky.querySelector('[data-pbc-sticky-btn]');
    if(stickyButton){
     stickyButton.disabled=button.disabled||!variant.available;
     const text=(button.querySelector('[data-atc-text-span]')||button).textContent.trim();
     setText(stickyButton,text);
     stickyButton.setAttribute('aria-label',text+' · '+price+' · '+note);
    }
   }
  }
  function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(update);}}
  main.addEventListener('input',schedule);
  main.addEventListener('change',schedule);
  main.addEventListener('click',schedule);
  const observer=new MutationObserver(records=>{
   if(records.every(r=>r.target.closest?.('.pb-purchase-summary')))return;
   schedule();
  });
  observer.observe(main,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['value','checked','disabled']});
  ['variant:change','variant:changed','product:variant-change','appstle:subscription:changed'].forEach(name=>document.addEventListener(name,schedule));
  update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
 else init();
})();
